export enum FontAwesomeIconAnimation {
  None = ' ',
  Beat = 'fa-beat',
  BeatFade = 'fa-beat-fade',
  Bounce = 'fa-bounce',
  Fade = 'fa-fade',
  Flip = 'fa-flip',
  Shake = 'fa-shake',
  Spin = 'fa-spin',
  SpinReverse = 'fa-spin fa-spin-reverse',
  SpinPulse = 'fa-spin-pulse'
}
